import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import MyProfile from '@/pages/MyProfile.vue'

import MyManagers from '@/pages/MyManagers.vue'
import MyManagersView from '@/pages/MyManagers/View.vue'
import MyManagersNew from '@/pages/MyManagers/New.vue'
import MyManagersEdit from '@/pages/MyManagers/Edit.vue'

import MyActivities from '@/pages/MyActivities.vue'
import MyActivitiesView from '@/pages/MyActivities/View.vue'
import MyActivitiesNew from '@/pages/MyActivities/New.vue'
import MyActivitiesEdit from '@/pages/MyActivities/Edit.vue'

import Products from '@/pages/Products.vue'
import ProductsView from '@/pages/Products/View.vue'
import ProductsNew from '@/pages/Products/New.vue'
import ProductsEdit from '@/pages/Products/Edit.vue'

import Quotation from '@/pages/Quotation.vue'
import QuotationView from '@/pages/Quotation/View.vue'
import QuotationNew from '@/pages/Quotation/New.vue'
import QuotationEdit from '@/pages/Quotation/Edit.vue'
import QuotationSubmission from '@/pages/Quotation/Submission.vue'

import Scholarship from '@/pages/Scholarship.vue'
import ScholarshipView from '@/pages/Scholarship/View.vue'
import ScholarshipNew from '@/pages/Scholarship/New.vue'
import ScholarshipEdit from '@/pages/Scholarship/Edit.vue'

import Job from '@/pages/Job.vue'
import JobView from '@/pages/Job/View.vue'
import JobNew from '@/pages/Job/New.vue'
import JobEdit from '@/pages/Job/Edit.vue'
import JobSubmission from '@/pages/Job/Submission.vue'

import Auth from '@/pages/Auth.vue'

import Expired from '@/pages/Expired.vue'
import Route404 from '@/pages/404.vue'

import ProfileInformation from '@/pages/ProfileInformation.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'

const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/my_profile',
		children: [
			{
				path: 'my_profile',
				name: 'My Profile',
				component: MyProfile
			},
			{
				path: 'profile_information',
				component: ProfileInformation,
			},
			{
				path: 'my_activities',
				component: MyActivities,
				children: [
					{
						path: '',
						component: MyActivitiesView
					},
					{
						path: 'new',
						component: MyActivitiesNew
					},
					{
						path: 'edit/:hash',
						component: MyActivitiesEdit
					},
					
				]
			},
			{
				path: 'products_and_services',
				component: Products,
				children: [
					{
						path: '',
						component: ProductsView
					},
					{
						path: 'new',
						component: ProductsNew
					},
					{
						path: 'edit/:hash',
						component: ProductsEdit
					},
					
				]
			},
			{
				path: 'quotation_and_bidding',
				component: Quotation,
				children: [
					{
						path: '',
						component: QuotationView
					},
					{
						path: 'new',
						component: QuotationNew
					},
					{
						path: 'edit/:hash',
						component: QuotationEdit
					},
					{
						path: 'submission/:hash',
						component: QuotationSubmission
					},
					
				]
			},
			{
				path: 'job_recruitment',
				component: Job,
				children: [
					{
						path: '',
						component: JobView
					},
					{
						path: 'new',
						component: JobNew
					},
					{
						path: 'edit/:hash',
						component: JobEdit
					},
					{
						path: 'submission/:hash',
						component: JobSubmission
					},
					
				]
			},
			{
				path: 'scholarship',
				component: Scholarship,
				children: [
					{
						path: '',
						component: ScholarshipView
					},
					{
						path: 'new',
						component: ScholarshipNew
					},
					{
						path: 'edit/:hash',
						component: ScholarshipEdit
					},
					
				]
			},
			{
				path: 'my_managers',
				component: MyManagers,
				children: [
					{
						path: '',
						component: MyManagersView
					},
					{
						path: 'new',
						component: MyManagersNew
					},
					{
						path: 'edit/:hash',
						component: MyManagersEdit
					},
					
				]
			},
			// {
			// 	path: 'administrators',
			// 	component: Administrators,
			// 	children: [
			// 		{
			// 			path: '',
			// 			component: AdministratorsView
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			component: AdministratorsEdit
			// 		}
			// 	]
			// }
		]
	},
	{
		path: '/auth/:token',
		component: Auth,
	},
	{
		path: '/expired',
		component: Expired
	},
	{
		path: '*',
		component: Route404
	},

]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js